module.exports = __webpack_public_path__ + "media/images/survey-send-71b074b5722096a1ee47c17a14651ff7.svg";